import { Injectable,EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }
  globalVariable: any;

  private storageEvent = new EventEmitter<string>();

  getItem(key: string) {
    return localStorage.getItem(key);
  }
  setItem(key: string, value: string){
    localStorage.setItem(key, value);
    this.storageEvent.emit(key);
  }
  onStorageEvent() {
    return this.storageEvent;
  }
  setGlobalVariable(value: any): void {
    this.globalVariable = value;
  }

  private isLoginButton = new BehaviorSubject<any>('false');

  setData(data: any) {
    this.isLoginButton.next(data);
  }

  getData() {
    return this.isLoginButton.asObservable();
  }
}
